<div>
  <mat-toolbar class="flex-direction-row flex-justify-between" role="heading">
    <div class="primary-color-legacy title-container">Presto-ESL</div>
    <div class="flex-justify-end flex-align-it-center">
      <app-outlet-selection (outletSelected)="onSelectOutlet()"></app-outlet-selection>

      <mat-icon>person</mat-icon>
      <span>{{ user.username }}</span>

      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        aria-label="Example icon-button with a menu"
      >
        <mat-icon color="primary">settings</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button (click)="logout()" mat-menu-item>
          <mat-icon>exit_to_app</mat-icon>
          <span i18n="@@logout">Logout</span>
        </button>
      </mat-menu>
    </div>
  </mat-toolbar>
  <navbar-component></navbar-component>
  <div *ngIf="!outletSelected">
    <ng-template #outletPopupSelection>
      <app-outlet-popup></app-outlet-popup>
    </ng-template>
  </div>
  
</div>

